import { SpacesOverview } from "@/components/spaces/spaces-overview.tsx";
import { m } from "@/paraglide/messages.js";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { pageTitle } from "@/utils/page-title.ts";

const spacesSearchSchema = z.object({
	code: z.string().optional(),
	state: z.string().optional(),
	// Set by an integration tile's "Connect" action to deep-link straight into the
	// wizard pre-selecting a provider, instead of landing on a blank Spaces list
	// and making the user re-find it in the picker. Validated against the real
	// provider list in `resolveDeepLinkProvider` — an unknown value is ignored.
	connect: z.string().optional(),
});

export const Route = createFileRoute("/_authenticated/dashboard/spaces/")({
	validateSearch: spacesSearchSchema,
	component: RouteComponent,
	head: () => ({
		meta: [{ title: pageTitle(m.spaces_title()) }],
	}),
});

function RouteComponent() {
	return <SpacesOverview />;
}
